import apiClient from "./api";

export async function getProvidersForInstitute(data) {
    try {
      const response = await apiClient.get("/eomws/getprovidersforinstitude", {params: data}); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
  }

  export async function getLocationPerProvider(data) {
    try {
      const response = await apiClient.get("/eomws/getlocationperprov", {params: data}); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
  }

  export async function getProviderOrigin(data) {
    try {
      const response = await apiClient.get("/eomws/getproviderorigin", {params: data}); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: "No response received",
          details: error.request,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: "Request setup error",
          details: error.message,
        };
      }
    }
  }